import { useSearchParams } from 'react-router';

import BookingFeedbackResults from '@/components/booking/booking-feedback-results';
import BookingFeedbackSpaces from '@/components/booking/booking-feedback-spaces';
import Tabs from '@/components/ui/tabs';

type Tab = 'responses' | 'spaces';

const TABS: readonly { key: Tab; label: string }[] = [
  { key: 'responses', label: 'Responses' },
  { key: 'spaces', label: 'Spaces & forms' },
];

/**
 * What clients thought of the spaces they booked, and the settings that ask them: each space's
 * switch and form. The tab is kept in the address (`?tab=spaces`), so a link can open on it.
 */
export default function BookingFeedbackPage() {
  const [params, setParams] = useSearchParams();
  const tab: Tab = params.get('tab') === 'spaces' ? 'spaces' : 'responses';

  return (
    <div className="flex flex-col gap-6">
      <Tabs
        label="Booking feedback"
        tabs={TABS}
        active={tab}
        onPick={(next) => setParams(next === 'responses' ? {} : { tab: next })}
      />
      {tab === 'responses' ? <BookingFeedbackResults /> : <BookingFeedbackSpaces />}
    </div>
  );
}
